import React, { useState, useEffect, useCallback } from "react";
import debounce from 'lodash/debounce';
import ReactDOM from "react-dom";
import collect from 'collect.js';



// Render the react block SearchResults on the div with id search-results-block__render-results
document.addEventListener("DOMContentLoaded", () => {
    const divToUpdate = document.querySelector("#search-results-block__render-results");
    if(divToUpdate) { 
        const SearchResults = () => {
            const url = new URL(window.location.href);
            
            const [initialized, setInitialized] = useState(false);
            const [loading, setLoading] = useState(false);
            const [results, setResults] = useState([]);
            const [links, setLinks] = useState({login: null, subscribe: null});
            const [searchTerm, setSearchTerm] = useState(url.searchParams.get("s") || '');
            const [displayFilters, setDisplayFilters] = useState(false);
            const [allFilters, setAllFilters] = useState([]);
            const [selectedFilters, setSelectedFilters] = useState([]);
            const [sorting, setSorting] = useState('relevance:desc');
            const [page, setPage] = useState(1);
            const [total, setTotal] = useState(0);
            
            // Pre-populate the selectedFilters array depending on the referrer
            useEffect(() => {
                if (allFilters.length == 0) return;
                
                const lastVisitedPostType = sessionStorage.getItem('lastVisitedPostType');
                const lastVisitedCategoryId = sessionStorage.getItem('lastVisitedCategoryId');
                
                if (lastVisitedPostType || lastVisitedCategoryId) {
                    const filters = [];
                    
                    if (lastVisitedPostType) {
                        const filter = collect(allFilters).where('type', 'postType').where('slug', lastVisitedPostType).first();
                        if (filter) filters.push(filter);
                    }
                    
                    if (lastVisitedCategoryId) {
                        const filter = collect(allFilters).where('type', 'category').where('id', parseInt(lastVisitedCategoryId)).first();
                        if (filter) filters.push(filter);
                    }
                    
                    setSelectedFilters(filters);
                } else {
                    updateFilters(allFilters);
                }
            }, [allFilters]);
            
            // Fetch the filters (post types and categories) from the WordPress REST API to be displayed on the page for users to filter results
            useEffect(() => {
                fetch(url.origin + "/wp-json/ifpbm/v1/searchFilters")
                .then((response) => response.json())
                .then((data) => {
                    setAllFilters(data);
                })
                .catch(error => console.error(error));
            }, []);

            // Run a search based on filter changes
            useEffect(() => {
                if (allFilters.length == 0) return;
                
                setInitialized(true);
                
                if (selectedFilters.length > 0 || searchTerm) {
                    delayedSearch(page, searchTerm, sorting, selectedFilters);
                } else {
                    setResults([]);
                    setTotal(0);
                    setPage(1);
                }
            }, [page, allFilters, searchTerm, sorting, selectedFilters]);

            // Push the selected filters to the selectedFilters array
            const updateFilters = (filter) => {
                let newSelectedFilters = [...selectedFilters];
                
                console.log(filter);
                
                // Check if the filter with the same slug exists in newSelectedFilters
                const filterIndex = newSelectedFilters.findIndex((item) => item.slug === filter.slug);
                
                if (filterIndex !== -1) {
                    // If the filter exists, remove it from newSelectedFilters
                    newSelectedFilters.splice(filterIndex, 1);
                } else {
                    // If the filter doesn't exist, add it to newSelectedFilters
                    newSelectedFilters.push(filter);
                }
                
                // Update the state with the newSelectedFilters
                setSelectedFilters(newSelectedFilters);
                
                // Reset the page number to 1
                setPage(1);
            }

            // Fetch search the results with a delay
            const delayedSearch = useCallback(
                debounce((page, searchTerm, sorting, filterBy) => {
                    setLoading(true);
                    
                    const params = new URLSearchParams;
                    params.append('page', page);
                    params.append('search', searchTerm);
                    params.append('sort_by', sorting.split(':')[0]);
                    params.append('sort_direction', sorting.split(':')[1]);
                    params.append('filter_by', filterBy.map(filter => filter.type + ':' + (filter.id || filter.slug)).join(','));
                    
                    fetch(
                    url.origin + "/wp-json/ifpbm/v1/search?" + params.toString()
                    )
                    .then((response) => response.json())
                    .then((data) => {
                        if (page > 1) {
                            setResults(results => [...results, ...data.results]);
                        } else {
                            setResults(data.results);
                        }
                        
                        setTotal(data.total);
                        
                        setLinks({
                            login: data.login_url,
                            subscribe: data.subscribe_url,
                        });
                    })
                    .catch((error) => console.error(error))
                    .finally(() => {
                        setLoading(false);
                    });
                }, 500),
                []
            );

            // Update searchTerm and the URL, and run the delayedSearch function
            const updateSearch = (searchTerm) => {
                setSearchTerm(searchTerm);
                setPage(1);
                // Update the URL
                window.history.pushState(null, null, url.origin + "/?s=" + searchTerm);
            }

            return (
                <>
                <div className="search-results__search">
                    <input className="search-results__search-input" type="search" placeholder="Search" value={searchTerm} onChange={(e) => updateSearch(e.target.value)} />
                    <div className="search-results__search-button" onClick={() => window.location.href = url.origin + "/?s=" + searchTerm}>
                        <svg className="search-results__search-icon" viewBox="0 0 24 24" width="24" height="24">
					        <path d="M13.5 6C10.5 6 8 8.5 8 11.5c0 1.1.3 2.1.9 3l-3.4 3 1 1.1 3.4-2.9c1 .9 2.2 1.4 3.6 1.4 3 0 5.5-2.5 5.5-5.5C19 8.5 16.5 6 13.5 6zm0 9.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"></path>
				        </svg>
                    </div>
                </div>
                
                <h1 className="search-results__number">
                    {loading ? (
                        <span>{searchTerm ? `Searching for "${searchTerm}"...` : 'Searching...'}</span>
                    ) : (
                        <>
                            {initialized && <span>{total} search results {searchTerm && `for ${searchTerm}`}</span>}
                        </>
                    )}
                </h1>
                
                <div className="search-results__results">
                    <div className="search-results__sorting">
                        <div className="search-results__order-by">
                            Order by
                            <select
                                onChange={e => setSorting(e.target.value)}
                                value={sorting}
                            >
                                <option value="relevance:desc">relevance</option>
                                <option value="date:desc">newest first</option>
                                <option value="date:asc">oldest first</option>
                            </select>
                        </div>

                        <div className="search-results__filters">
                            <div className={`search-results__filters-toggle ${displayFilters ? 'active' : ''}`} onClick={() => setDisplayFilters(!displayFilters)}>                        
                                Filters <i className="fa-solid fa-chevron-down"></i>
                            </div>
                        </div>
                        <div className="search-results__filters-list">
                                {displayFilters && allFilters.length > 0 && (
                                    allFilters.map((filter) => {
                                    return (
                                        //When the user clicks on the div, the updateSearch function is called passing filter.name as a parameter.
                                        <div
                                        className={`search-results__filter ${collect(selectedFilters)
                                            .where('slug', filter.slug)
                                            .isNotEmpty()
                                            ? 'active'
                                            : ''}`}
                                        key={filter.slug}
                                        onClick={() => updateFilters(filter)}
                                        >
                                        <p className="search-results__filter-title">{filter.name}</p>
                                        </div>
                                    );
                                    })
                                )}
                            </div>
                    
                    </div>
            
                    {results.map((result) => {
                        return (
                            <a href={result.paid ? null : result.permalink} className="search-results__result">
                                {
                                    result.category.length > 0
                                    ?  <p className="search-results__result-category">{result.category[0].name}</p> 
                                    : <p className="search-results__result-category">{result.postType}</p>
                                }

                                <div>
                                    <h2 className="search-results__result-title" dangerouslySetInnerHTML={{ __html: result.title }}></h2>
                                </div>
                                <p className="search-results__result-excerpt"  dangerouslySetInnerHTML={{ __html: result.excerpt }}></p>
                                
                                {result.paid && (
                                    <div className="search-results__paid-overlay">
                                        <a href={links.login}>Login</a> or <a href={links.subscribe}>Subscribe</a>
                                    </div>
                                )}
                            </a>
                        );
                    })}
                    
                    {results.length < total && !loading && (
                        <div className="search-results__load-more">
                            <button onClick={() => setPage(page + 1)}>Load More</button>
                        </div>
                    )}
                </div>

                </>
            );
            }

        ReactDOM.render(<SearchResults />, divToUpdate);

    }
});
